class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[name="q"]');
    this.predictiveSearchResults = this.querySelector('[data-ref="predictive-search"]');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );

    // Suivi des recherches (pixel langue-navigateur, table Supabase tmc_site_searches).
    // Le clic part vers une autre page : on le confie au sessionStorage, le pixel l'envoie
    // au chargement de la page suivante.
    this.predictiveSearchResults.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link || !this.pendingSearch) return;
      clearTimeout(this.searchEventTimer);
      try {
        const clickedPath = new URL(link.getAttribute('href'), window.location.origin).pathname;
        sessionStorage.setItem('tmc_search_click', JSON.stringify(this.searchPayload('click', clickedPath)));
      } catch (e) {}
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.hide();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(Theme.routes.predictive_search_url + `?q=${searchTerm}&section_id=predictive-search&resources[type]=product,collection,page,article`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.hide();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.show();
        this.queueSearchEvent(searchTerm);
      })
      .catch((error) => {
        this.hide();
        throw error;
      });
  }

  // Un événement quand la saisie reste stable 1,5 s, pas un par lettre tapée.
  queueSearchEvent(searchTerm) {
    clearTimeout(this.searchEventTimer);
    this.pendingSearch = searchTerm;
    this.searchEventTimer = setTimeout(() => {
      if (this.lastPublished === searchTerm || !window.Shopify?.analytics?.publish) return;
      this.lastPublished = searchTerm;
      window.Shopify.analytics.publish('tmc:search', this.searchPayload('idle', null));
    }, 1500);
  }

  searchPayload(trigger, clickedUrl) {
    const count = (selector) => this.predictiveSearchResults.querySelectorAll(selector).length;
    return {
      query: this.pendingSearch,
      trigger,
      clicked_url: clickedUrl,
      path: window.location.pathname,
      products: count('.predictive-search__item-product'),
      collections: count('.predictive-search__item-collection'),
      pages: count('.predictive-search__item-page, .predictive-search__item-article'),
    };
  }

  show() {
    this.predictiveSearchResults.style.display = 'block';
  }

  hide() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
